export default
    {
        path:'/auction',
        mapPath:'/auction',
        component: require('./index').default,
        props: true,
        parent:'root',
        meta:{
            title:'竞价大厅',
        },
        name:'auctionHall'
    }
